
// 使うもののみ定義している
export interface AppCredentials {
  client_id: string;
  client_secret: string;
}

// 使うもののみ定義している
export interface OAuthToken {
  access_token: string;
}

export class HttpErrorItem {
  constructor(
    public code: number,
    public message: string,
    public jsonPromise: Promise<any>
  ) { }
}

// 使うもののみ定義している
export type Account = {
  id: string;
  acct: string;
  display_name: string;
  url: string;
  avatar_static: string;
}

// 使うもののみ定義している
export type Status = {
  id: string;
  created_at: string;
  sensitive: boolean;
  spoiler_text: string;
  uri: string;
  url: string;
  content: string;
  account: Account;
  media_attachments: unknown[];
  reblog: Status | null;
}

export type TimelineMode = {
  type: 'timeline'
  tag?: string
  localOnly: boolean
}

export type UserMode = {
  type: 'user'
  userAcct: string
}

export type ViewMode = TimelineMode | UserMode

export type UserFetchMode = {
  type: 'user',
  userId: string,
}

export type FetchMode = TimelineMode | UserFetchMode

export interface ShowTimelineEvent {
  server: string
  id: string
  mode: ViewMode
  bearerToken: string
}

export type TimelineIdSpec =
  | { type: 'min'; id: string }
  | { type: 'max'; id: string }
  | { type: 'none' };
